/* eslint-disable no-use-before-define */
import React from 'react'
import useChart from './use-chart'
import { Status } from '../twd'

const formatName = (n) => {
    return `${parseInt(n, 10)} ${n.endsWith('M') ? 'Month' : 'Year'} Note`
}


export const Table = () => {

    const { chartData, chartDataStatus } = useChart()

    if (chartDataStatus!==Status.LOADED) return null

    return <table>
    <caption>U.S. Yield Curve</caption>
    <tbody>
    { chartData.map( (a,i) => <tr key={i}>
        <td>{formatName(a['name'])}
        Current {a.current!==null ? a.current + '%' : 'Empty'}
        1 Month Ago {a['1mo']!==null ? a['1mo'] + '%' : 'Empty'}
        6 Months Ago {a['6mo']!==null ? a['6mo'] + '%' : 'Empty'}
        1 Year Ago {a['1yr']!==null ? a['1yr'] + '%' : 'Empty'}
        </td>
    </tr>)}
    </tbody>
    </table>
 }


// WEBPACK FOOTER //
// ./src/treasury-chart/table.js